// extracted by mini-css-extract-plugin
export default {"Link":"Guidelines_Link__MTrG-"};